/**
 * @file Center atom — centering container primitive.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family; the only sanctioned import path for app code (RFC §3).
 * @module components/atoms/Center
 */
export { Center } from "@/components/ui/center";
